import React from "react";
import { useTranslation } from "react-i18next";
import GroupsList from "../components/groups/GroupList";

function Groups() {
  const { t } = useTranslation();
  return (
    <div id="artur-groupsOverview">
      <div className="container">
        <div className="row">
        <div className="col-md-12 col-md-offset-2 content">
            <h2>{t("admin.group.h1")}</h2>
              <GroupsList/>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Groups;
